import { useState } from "react";

import { twMerge } from "tailwind-merge";

type WhySmartscriptsProps = {
  className?: string;
};

const WhySmartscripts = ({ className }: WhySmartscriptsProps) => {
  const [showWhyHelp, setShowWhyHelp] = useState<boolean>(false);

  return (
    <div
      className={twMerge(
        "overflow-hidden rounded-[8px] border border-solid border-[#e5e7eb]",
        className
      )}
    >
      <button
        type="button"
        onClick={() => setShowWhyHelp((prev) => !prev)}
        className="flex w-full cursor-pointer items-center justify-between border-none bg-[#f9fafb] px-[16px] py-[12px] text-left"
      >
        <span className="flex items-center gap-[8px] text-[14px] font-medium text-[#1f2937]">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#24a9a7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          Why SmartScripts?
        </span>
        <span className="flex items-center gap-[6px] text-[13px] text-[#9ca3af]">
          {showWhyHelp ? "Hide" : "Show"}
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={twMerge(
              "transition-transform duration-200",
              showWhyHelp ? "rotate-180" : "rotate-0"
            )}
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>

      {showWhyHelp && (
        <div className="border-0 border-solid border-[#e5e7eb] px-[16px] py-[16px]">
          <p className="mb-[14px] text-[15px] font-semibold text-[#1f2937]">
            Institutional Insights. Zero Compliance Risk.
          </p>
          <ol className="m-0 flex list-none flex-col gap-[10px] p-0">
            {[
              <>
                Primary research is critical, but traditional expert calls can
                be <b>slow, expensive</b>, and carry{" "}
                <b>MNPI transmission risks</b>.
              </>,
              <>
                This platform generates{" "}
                <b>Synthetic Expert Network Transcripts on Demand</b> and{" "}
                <b>Grounded in Public Information only</b> — no scheduling, no
                NDAs, no risk.
              </>,
              <>
                Get sharp, data-driven market insights and discover the right
                questions to ask — <b>instantly and safely</b>.
              </>,
            ].map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-[10px] text-[13px] leading-relaxed text-[#4b5563]"
              >
                <span className="mt-[1px] flex h-[20px] w-[20px] flex-shrink-0 items-center justify-center rounded-full bg-smart-teal/10 text-[11px] font-semibold text-smart-teal">
                  {i + 1}
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ol>
          <p className="mb-0 mt-[14px] text-[14px] font-semibold text-smart-teal">
            Faster. Safer. Smarter.
          </p>
        </div>
      )}
    </div>
  );
};

export default WhySmartscripts;
